"use strict";

/**
 * Toolbar should handle
 * - 'module' navigation
 * - Search
 * - Help
 */


class AppToolbarCtrl {

    constructor($http, $mdSidenav, $timeout, $window, $state, $mdDialog) {
        this.$http = $http;
        this.$state = $state;
        this.$mdSidenav = $mdSidenav;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$mdDialog = $mdDialog;
        this.searchData = {};
        this.Q = '';

        this.menuLoading = false;
        this.menuData = [];
        this.menuActive = {};

        // Call the checkmessage interval and define a interval time of 5 minutes
        //this.checkInterval = 5 * 60 * 1000;
        this.checkInterval = 5 * 60 * 1000;
        this.checkUnreadMessagesInterval();

        this.loadStations();
    }

    openMenu($mdMenu, $event) {
        this.loadStations();
        $mdMenu.open($event);
    }

    loadStations() {
        this.menuData = [];
        this.menuLoading = true;
        this.$http.get('/user/stations').then((response) => {
            this.menuData = response.data.stations;
            this.menuActive = response.data.active;

            this.menuLoading = false;
        });
    }

    querySearch(query) {

        //Dont sent empty search strings to the servers
        if (!query) {

            this.searchData = {};

            return;
        }

        this.$http.get('/search/' + query).then((response) => {
            this.searchData = response.data;
        });
    }

    clickCatcher() {

        this.showToolbar = false;
        this.Q = '';
        this.searchData = {};
    }

    focusOnInput() {

        let element = this.$window.document.getElementById('searchQ');

        this.$timeout(function () {
            element.focus();
        }, 500);
    }

    toggleSideBar() {

        this.$mdSidenav('right').toggle();
    }

    openSearch(searchText, $event) {
        this.$mdDialog.show({
            controller: 'advancedSearchCtrl',
            controllerAs: 'asCtrl',
            templateUrl: "advancedSearch.ngTemplate",
            parent: angular.element(document.querySelector('#searchContainer')),
            targetEvent: $event,
            locals: {
                searchText: searchText
            },
            hasBackdrop: false,
            clickOutsideToClose: true,
            escapeToClose: true,
            openFrom: '.search-input',
            closeTo: '.search-input',
            multiple: true
        })
    }

    openSupportDialog($event) {
        let button = angular.element(document.querySelector('.help-button'));
        this.$mdDialog.show({
            controller: 'supportDialogCtrl',
            controllerAs: 'ctrl',
            templateUrl: "/partial/app.partials.dialogs.supportDialog",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: $event,
            hasBackdrop: true,
            clickOutsideToClose: false,
            escapeToClose: true,
            openFrom: button,
            closeTo: button,
            multiple: true
        })
    }

    checkUnreadMessages() {
        this.$http.get('/userunreadnotifications/').then((response) => {
            this.messageData = response.data;
            this.unreadMessageCount = this.messageData.total;
        });
    }

    checkUnreadMessagesInterval() {
        this.checkUnreadMessages();
        setInterval(() => {
            // Has to be done this way because setInterval expects a function which we did not define yet.
            this.checkUnreadMessages();
        }, this.checkInterval);
    }

    openMessageDialog($event) {
        let button = angular.element(document.querySelector('.help-button'));
        this.$mdDialog.show({
            controller: 'messageDialogCtrl',
            controllerAs: 'ctrl',
            templateUrl: "/partial/app.partials.dialogs.messageDialog",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: $event,
            hasBackdrop: true,
            clickOutsideToClose: false,
            escapeToClose: true,
            openFrom: button,
            closeTo: button,
            multiple: true
        }).then(() =>{
            this.checkUnreadMessages();
        });
    }

    tryToReconnect() {
        window.location.reload();
    }
}


AppToolbarCtrl.$inject = ['$http', '$mdSidenav', '$timeout', '$window', '$state', '$mdDialog'];


module.exports = AppToolbarCtrl;
